import { render } from "./ChildInfoPage.vue?vue&type=template&id=0ee5e2b2&ts=true"
import script from "./ChildInfoPage.vue?vue&type=script&lang=ts"
export * from "./ChildInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__